export default {
  it: {
    items: [
      {
        h4: 'Televisione',
        p:
          'Offerta crescente di canali, cambiamenti nelle abitudini di consumo e differenziazione fra target, valore interattivo e sociale dell’esperienza (dove convergono «post» e «spot»). ',
        t:
          'Per tutti questi fattori, l’audience televisiva diventa sempre più sfaccettata e non la troviamo più di fronte a un solo schermo. Fluidità e specificità di contenuti e device rendono più complessa la composizione del pubblico (o meglio, dei pubblici), dischiudendo importanti opportunità di raggiungere i target più adatti a ogni progetto, grazie alla moltiplicazione dei touchpoint, dei dispositivi e delle interazioni.',
      },
      {
        h4: 'Digital',
        p:
          'Gli investimenti nell’advertising online crescono a ritmo costante,  con continui aggiustamenti nelle tecnologie, modalità, formati. Dall’ormai classica display ai video, al native e social advertising, alla tecnologia del programmatic.',
        t:
          'L’evoluzione del digitale passa dai numeri dei big data e del real time bidding, dalla valorizzazione dei contenuti, dal ruolo sempre più centrale dei dispositivi “personali” e dei loro display più piccoli. In questo contesto movimentato e ricco di opportunità, vi aiutiamo a scegliere la strategia più adatta al vostro progetto.',
      },
      {
        h4: 'Radio',
        p:
          'In equilibrio tra passato e la futuro, il consumo della radio è trasversale per età e localizzazione, dividendosi fra modalità nuove (streaming, podcast) e canoniche, con una sempreverde predilizione per l’ascolto in movimento: i picchi del cosiddetto drive time.',
        t:
          'Uno scenario dove si intrecciano contesto globale, ambiti locali e stazioni che individuano target specifici.',
      },
      {
        h4: 'Ooh',
        p:
          'Out of Home: essere presenti sul territorio, per creare engagement e un punto di contatto fisico.',
        t:
          'Un canale tradizionale, da reinventare con le possibilità contemporanee, dove il territorio stesso diventa un palcoscenico sfaccettato dove integrare la visibilità concreta del mezzo (affissione, mezzi pubblici) con progetti speciali e interazione multicanale. Magari, giocando sulla localizzazione del contenuto.',
      },
      {
        h4: 'Cinema',
        p:
          'Un mezzo di grande forza emotiva e visiva, che è il complemento ideale di una strategia video di successo. Come l’affissione permette di agire sia in ambito nazionale che locale, con campagne tradizionali o attività di engagement in sala.',
        t:
          'Gli spettatori sono in crescita come la qualità dei titoli  in programmazione, e con una creatività mirata si può ottenere grande memorabilità e diffusione virale del contenuto.',
      },
      {
        h4: 'Stampa',
        p:
          'Nonostante le difficoltà del settore, per alcuni target stampa periodica e quotidiana danno sempre opportunità importanti per comporre il media mix.',
        t:
          'Selezionando le testate in base ai contenuti editoriali, utilizzando formati adeguati a garantire l’impatto e pianificando diversi tipi di visibilità (magari, con una iniziativa editoriale speciale o con l’integrazione online/offline) si può amplificare il successo di una campagna.',
      },
      {
        h4: 'Progetti Speciali',
        p:
          'Qualsiasi canale scegliamo insieme per comporre il media mix, possiamo realizzare un progetto su misura per voi: con mezzi, contenuti, touchpoint e calendari inediti “fuori catalogo”',
        t:
          '',
      },
    ],
  },
  en: {
    items: [
      {
        h4: 'Television',
        p:
          'Growing choice of channels, changes in consumer habits and differentiation between targets, interactive and social value of the experience (where «post» and «spot» converge).',
        t:
          'Due to all these factors, television audience has become incrementally more multifaceted and segmented. Fluidity and content/device relevance make the audience composition more complex, but also allow, when done with skill, the opportunity to reach better suited targets for each project thanks to multiple touchpoints, devices and interactions.',
      },
      {
        h4: 'Digital',
        p:
          'Web advertising investments grow by the minute, with continous updates to technologies, methods and formats. Starting from the classic display or video all the way to native and social advertising and programmatic.',
        t:
          'The digital evolution touches big data and real time bidding, content enhancement and in the ever more topical role of personal devices (and the smaller screens). In this eventful context full of opportunities, we support you in choosing the best strategy for your project.',
      },
      {
        h4: 'Radio',
        p:
          'In equilibrium between past and future, radio consumption is diagonal across ages and countries and is divided between new approaches (streaming, podcast) and classic ones, with an evergreen preference towards listening on the go: the peaks of the so.called drive time.',
        t:
          'A scenario where global and local context meet specific targets.',
      },
      {
        h4: 'Ooh',
        p:
          'Out of Home: to be present on territory, creating engagement and a physical touchpoint.',
        t:
          'A traditional channel that can be reinvented with contemporary options, where territory itself becomes the multifaceted scene where to present our product (billboards, public transport) via special projects and multi-channel interaction, potentially playing with content localisation.',
      },
      {
        h4: 'Cinema',
        p:
          'A channel characterized by a strong emotional and visual component, the ideal complement to a succesfull video strategy allowing to act both on a national or local scale, with traditional campaigns or engagement activities in the halls.',
        t:
          'The number of spectators is growing as well as the quality of the movies. Both these elements can be used thanks to a curated creativity able to achieve great memorability and viral content.',
      },
      {
        h4: 'Stampa',
        p:
          'Despite the hardships, towards particular targets periodical and daily press are still bearers of important opportunities for the perfect media mix',
        t:
          'By selecting newspapers and editorials based on their content, choosing the correct formats to ensure visual impact and planning diversified ways of presentation (as an example via a special editorial initiative or the online/offline integration) it is possible to amplify the success of a campaign.',
      },
      {
        h4: 'Special Projects',
        p:
          'Whichever channel we may choose to compose the media mix, we’re always able to create a custom project for your needs through media, content, touchpoints and out of the box ideas.”',
        t:
          '',
      },
    ],
  },
};
